// NodeDateTimeField.jsx

import React from 'react';

// CSS
import './NodeDateTimeField.css';

// Components
import NodeDateTimeInput from 'node/form/fields/datetime/NodeDateTimeInput';
import NodeTemporalReadOnlyValue from 'node/form/fields/utilities/NodeTemporalReadOnlyValue';

/**
 * NodeDateTimeField
 *
 * Displays a schema-driven datetime field with inline date/time controls.
 * In readOnly / previewMode: friendly label (e.g. Jul 27, 2026, 10:00 AM).
 *
 * @param {object} value - Current field value.
 * @param {Function} onChange - Callback when datetime changes.
 * @param {boolean} [readOnly=false]
 * @param {boolean} [previewMode=false]
 *
 * @returns {ReactNode} The rendered component.
 */
const NodeDateTimeField = ({
  value,
  onChange,
  readOnly = false,
  previewMode = false,
}) => {
  const isReadOnly = Boolean(readOnly || previewMode);

  if (isReadOnly) {
    return (
      <div className="node-date-time-field-container is-readonly">
        <NodeTemporalReadOnlyValue value={value} fieldType="datetime" />
      </div>
    );
  }

  return (
    <div className="node-date-time-field-container">
      <NodeDateTimeInput
        className="node-date-time-field-picker"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

NodeDateTimeField.displayName = 'NodeDateTimeField';

export default NodeDateTimeField;
